import { ArrowRight, ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface TrustPledgeModalProps {
  onContinue: () => void;
}

export const TrustPledgeModal = ({ onContinue }: TrustPledgeModalProps) => {
  return (
    <div
      className="fixed inset-0 z-50 flex flex-col overflow-hidden"
      style={{ backgroundColor: "#D8F3DC" }}
    >
      {/* Static background blobs - no animation */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute top-16 -left-20 w-72 h-72 rounded-full"
          style={{ 
            backgroundColor: "#B7E4C7",
            filter: "blur(60px)",
          }}
        />
        <div
          className="absolute top-1/4 -right-16 w-80 h-80 rounded-full"
          style={{ 
            backgroundColor: "#B7E4C7",
            filter: "blur(60px)",
          }}
        />
        <div
          className="absolute bottom-32 left-1/4 w-64 h-64 rounded-full"
          style={{ 
            backgroundColor: "#B7E4C7",
            filter: "blur(60px)",
          }}
        />
        <div
          className="absolute bottom-1/3 right-1/4 w-56 h-56 rounded-full"
          style={{ 
            backgroundColor: "#B7E4C7",
            filter: "blur(60px)",
          }}
        />
      </div>

      <div className="flex-1 flex flex-col justify-center items-center px-8 py-12 relative z-10">
        {/* Glassmorphism cart icon - updated for light bg */}
        <div className="relative mb-10">
          <div 
            className="w-32 h-32 rounded-3xl backdrop-blur-xl flex items-center justify-center shadow-xl overflow-hidden"
            style={{ 
              backgroundColor: "rgba(255, 255, 255, 0.4)",
              border: "1px solid rgba(27, 67, 50, 0.2)"
            }}
          >
            <ShoppingCart className="w-16 h-16 text-[#1B4332]" strokeWidth={1.5} />
          </div>
        </div>

        {/* Typography */}
        <h1
          className="text-5xl font-bold mb-4"
          style={{ color: "#081C15" }}
        >
          Metabolic
        </h1>

        <p
          className="text-lg text-center max-w-xs mb-12"
          style={{ color: "#2D6A4F" }}
        >
          Healthier automated grocery lists
        </p>

        {/* CTA Button */}
        <Button
          onClick={onContinue}
          className="h-14 px-10 text-base font-semibold rounded-full transition-all shadow-lg hover:shadow-xl hover:scale-105"
          style={{ 
            backgroundColor: "#52B788",
            color: "#081C15",
          }}
        >
          Get Started
          <ArrowRight className="w-5 h-5 ml-2" />
        </Button>

        {/* Legal Links */}
        <div className="mt-8 flex items-center gap-4 text-sm" style={{ color: "#2D6A4F" }}>
          <Link to="/privacy" className="underline hover:opacity-80 transition-opacity">
            Privacy Policy
          </Link>
          <span>•</span>
          <Link to="/terms" className="underline hover:opacity-80 transition-opacity">
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  );
};
